import XLSX from "xlsx";
import Swal from "sweetalert2";
import { jsPDF } from "jspdf";
import dayjs from "dayjs";

export async function handleExcelExport(id, sheet, name) {
  try {
    var elt = document.getElementById(id);
    var wb = XLSX.utils.table_to_book(elt, { sheet: sheet, raw: true });

    return await XLSX.writeFile(wb, `${name}-${Date.now()}.` + "xlsx");
  } catch (error) {
    Swal.fire({
      icon: "error",
      title: "Oops...",
      text: error,
    });
  }
}
export const exportToExcel = async (data, name) => {
  try {
    // const response = await axios.get("https://api.example.com/data");
    // const jsonData = response.data;

    // Convert JSON to worksheet
    const worksheet = XLSX.utils.json_to_sheet(data);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

    // Save to Excel file
    XLSX.writeFile(workbook, `${name}-${Date.now().toString()}.xlsx`);
  } catch (error) {
    console.error("Error exporting to Excel:", error);
  }
};
export async function handlePdfExport(id) {
  try {
    var doc = new jsPDF();
    await doc.html(document.getElementById(id), {
      callback: function (doc) {
        doc.save();
      },
      x: 10,
      y: 10,
    });
  } catch (error) {
    Swal.fire({
      icon: "error",
      title: "Oops...",
      text: error,
    });
  }
}

export function excelToJson(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();

    reader.onload = (e) => {
      try {
        const data = new Uint8Array(e.target.result);
        const workbook = XLSX.read(data, { type: "array" });

        const jsonResult = {};

        workbook.SheetNames.forEach((sheetName) => {
          const worksheet = workbook.Sheets[sheetName];
          jsonResult["data"] = XLSX.utils.sheet_to_json(worksheet);
        });

        resolve(jsonResult);
      } catch (error) {
        reject(error);
      }
    };

    reader.onerror = (error) => reject(error);

    reader.readAsArrayBuffer(file);
  });
}

export function excelSerialToDayJs(serial) {
  if (typeof serial !== "number" || serial < 1 || serial > 2958465) {
    let x = serial.trim().split("-") || serial.trim().split("/");

    return dayjs(`${x[1]}-${x[0]}-${x[2]}`).format("YYYY-MM-DD"); // Not a valid Excel date
  }

  const excelEpoch = dayjs("1900-01-01"); // Excel starts on Jan 1, 1900
  return excelEpoch.add(serial - 2, "day").format("YYYY-MM-DD");
}
